import { render, staticRenderFns } from "./PlanSteps.vue?vue&type=template&id=3830c4e4"
import script from "./PlanSteps.vue?vue&type=script&lang=js"
export * from "./PlanSteps.vue?vue&type=script&lang=js"
import style0 from "./PlanSteps.vue?vue&type=style&index=0&id=3830c4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports